module.exports = __webpack_public_path__ + "img/joconde_2500px.9f74b292.png";